import { MTagProps, MTagType } from './MTag.types';
import * as Styled from './MTag.styles';
import { AIcon, AIconSize } from '../../atoms/AIcon/index';
import { ALabel, ALabelSize } from '../../atoms/ALabel/index';

const COMPONENT_NAME = 'm-web-ui-kit-MTag';
const TEST_ID = 'web-ui-kit-MTag';

export function MTag({ aIcon, aLabel, type = MTagType.Default, ...rest }: MTagProps) {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} type={type} {...rest}>
      {aIcon?.icon && <AIcon {...aIcon} size={AIconSize.S} />}
      {<ALabel {...aLabel} size={ALabelSize.XS} />}
    </Styled.Wrapper>
  );
}

export { MTagType, TEST_ID as M_TAG_TEST_ID };
